export const buildSidebar = (options) => {
  return options.sidebar
}
